import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'bis-accessibilite',
  templateUrl: './accessibilite.component.html',
  styleUrls: ['./accessibilite.component.css']
})
export class AccessibiliteComponent implements OnInit {
  constructor(
    private router: Router, 
  ) {
  }

  ngOnInit() {
  }

  public retourSaisie(): void {
    this.router.navigate(['/saisie']);
  }
  
}